/**
 * Checks if a franchisee user has action access (review, edit, sent, backups, official) to an order.
 * Granted if:
 * 1. The user's franchisee matches the order's franchisee (executing unit), OR
 * 2. The user's franchisee matches the client's franchisee (client owner unit) AND the order is finished by inspector.
 */
export function hasFranchiseeActionAccess(user, order) {
  if (!order || !user) return false;

  const userFranchiseeId = user.franchiseeId || user.profile?.franchisee_id;
  const orderFranchiseeId = order.franchisee_id;
  const isExecutingFranchisee = !orderFranchiseeId || userFranchiseeId === orderFranchiseeId;

  if (isExecutingFranchisee) return true;

  const clientFranchiseeId = order.client_franchisee_id;
  const isClientOwnerFranchisee = Boolean(userFranchiseeId && clientFranchiseeId && userFranchiseeId === clientFranchiseeId);
  const isFinishedByInspector =
    ['FINALIZED_BY_DEVICE', 'FINISHED'].includes(order.status);

  return Boolean(isClientOwnerFranchisee && isFinishedByInspector);
}
